

<template>
	<section class="clearfix" style="display:flex">
		<compWrapper title="部门列表" theme="primary" style="width:30%">
			<componentNode class="margin-left-15 margin-top-15" @on-data="getNodeData" :cuttentDepartment="selectedDepartment" :dataList="companyList" v-if="isReady"/>
		</compWrapper>
        <div style="width:70%; margin-left:10px;">
            <div >
                <div style="position: relative;line-height: 36px;">
                    <span style="font-size:16px;font-weight: 600;">
                        {{selectedDepartment.name}}
                    </span>
                    <Button style="position: absolute; top: 9%;margin-left: 5px;" @click="edit">编辑</Button>
                </div>
                <h2 style="font-size:12px">
                    <a style="font-style: italic;" @click="getNodeData(superiorDepartment.id)">{{superiorDepartment?superiorDepartment.name:''}}</a>
                    {{superiorDepartment?'> '+selectedDepartment.name:selectedDepartment.name}}
                </h2>
            </div>
            <compWrapper title="下级部门" theme="primary">
                <componentDetail class="margin-left-15 margin-top-15" @on-update="getAllDept" :cuttentDepartment="selectedDepartment.id" :deptList1="companyList" v-if="isReady"/>
            </compWrapper>
            <compWrapper title="部门成员" theme="primary">
                <componentMemeber class="margin-left-15 margin-top-15" ref="member" :cuttentDepartment="selectedDepartment.id" :companyList1="companyList" v-if="isReady"/>
            </compWrapper>
        </div>
		<vLoading size="large" transfer :loading="loading"></vLoading>
        <!-- 公共弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" @on-close="closemodalprops"></component>
        </compModal>
	</section>
</template>

<script>
import { HttpGetDeptList } from '@/service/department/departmentmanage.js'
import componentNode from './node';
import componentDetail from './detail';
import componentMemeber from './member.js';
import compAddDept from './adddept.vue'
import mixin from '../mixins'

export default {
    mixins: [ mixin ],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		componentNode,
        componentDetail,
        componentMemeber,
        compAddDept
	},
	data() {
		return {
			isSystem: false,
			loading: false,
            selectedDepartment: {},
            superiorDepartment: undefined,
            modalProps:{},
            companyList: [],
            isReady: false,
		};
	},
	computed: {
	},
	created() {
        this.getAllDept()
    },
	methods: {
        async getAllDept() {
            this.loading = true;
            await HttpGetDeptList().then(res => {
                this.companyList = res.data;
                this.isReady = true;
                this.loading = false;
            }, err => {
                this.$Message.error(err.message)
            });
            this.getNodeData(this.selectedDepartment.id)
        },
		cancel() {
		},
        edit(){
            this.modalProps = {
                show: true,
                title:'编辑部门',
                width: 460,
                component: "compAddDept",
                showFooter:false,
                selectDeptId: this.selectedDepartment.id,
                deptList: this.companyList,
                type: 'edit',
                on:{
                    'on-update':()=>{
                        this.getAllDept();
                        this.$refs.member.updateList({deptId:this.selectedDepartment.id})
                    },
                    'on-close':()=>{
                        this.closemodalprops
                    }
                }
            };
        },
        closemodalprops(){
            this.modalProps = {}
        },
		getNodeData(id) {
            this.selectedDepartment = this.companyList.filter(item => item.id === id)[0]
            this.superiorDepartment = this.companyList.filter(item => item.id === this.selectedDepartment.parentId)[0]
		},
		async updateMenu() {

		},
	},
};
</script>
